/* @ngInject */
export default function AddTemplateVariableCtrl (
  $uibModalInstance,
  TemplateVariable,
  templateVariable,
  variables
) {
  const vm = this

  vm.templateVariable = templateVariable

  vm.isNew = templateVariable._isNew()

  vm.existingVariableNames = variables
    .filter(variable => variable.id !== templateVariable.id)
    .map(variable => variable.name)

  vm.submit = function () {
    vm.setDisable()
    templateVariable._save()
      .then(
        () => $uibModalInstance.close(templateVariable)
      )
      .finally(vm.unsetDisable)
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
